import { style } from "@vanilla-extract/css";
import { cellStyles } from "plos/src/components/Table/tables.css";
import { vars } from "plos/src/styles";

export const winnersRankColumn = style({
  width: "10%",
  textAlign: "start",
});

export const winnersTeamColumn = style({
  width: "70%",
  textAlign: "start",
});

export const winnersPointsColumn = style({
  width: "15%",
  textAlign: "end",
});

export const winnersRankCell = style([
  cellStyles,
  {
    textAlign: "start",
  },
]);

export const winnersPointsCell = style([
  cellStyles,
  {
    textAlign: "end",
  },
]);

export const managerName = style({
  fontFamily: vars.fonts.regular,
});
